import AppRouter from "./components/AppRouter";
import React, {useContext, useEffect, useState} from "react";
import {Context} from "./index";
import {observer} from "mobx-react-lite";
import {checkToken} from "./http/userAPI";
import jwtDecode from "jwt-decode";
import SpinnerDark from "./components/UI/SpinnerDark";


const App = observer(() => {
    const {user} = useContext(Context)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    user.logout();
                    return;
                }
                const ok = await checkToken();
                if (cancelled) {
                    return;
                }
                if (ok) {
                    try {
                        user.setUser(jwtDecode(token));
                        user.setAuth(true);
                    } catch {
                        user.logout();
                    }
                } else {
                    user.logout();
                }
            } catch {
                if (!cancelled) {
                    user.logout();
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- инициализация сессии один раз при монтировании
    }, []);

    if (loading){
        return (
            <SpinnerDark/>
        )
    }

  return (
        <AppRouter/>
  );
});

export default App;
